/* eslint-disable no-undef, no-unused-vars, no-new */

import axios from 'axios';
import Swal from 'sweetalert2';
import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import _ from 'lodash';
import Flash from './components/Html/common/Flash';

if (process.env.NODE_ENV === 'production') {
  window.bugsnagClient = Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    appVersion: APP_VERSION,
    plugins: [new BugsnagPluginVue()],
    collectUserIp: false,
    autoTrackSessions: false,
    generateAnonymousId: false,
    redactedKeys: [
      /^name$/i,
      /^email$/i,
      /^phone$/i,
      /^city$/i,
      /^address$/i,
      /^zip$/i,
      /^birth_date$/i,
      /^person$/i,
      /^country$/i,
      /^password$/i,
      /^cookie$/i,
      /^authorization$/i,
      /^php-auth-user$/i,
      /^php-auth-pw$/i,
      /^php-auth-digest$/i,
      /^credit_card$/i,
      /^number$/i,
      /^expiration_month$/i,
      /^expiration_year$/i,
      /^cvc$/i,
      /^token$/i,
      /^clientIp$/i
    ]
  });

  const bugsnagVue = Bugsnag.getPlugin('vue');
  bugsnagVue.installVueErrorHandler(Vue);
}

window.VueEventHub = new Vue();

const Sticky = require('sticky-js');
require('./helpers/Functions.js');

Vue.prototype.$http = axios;
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common[
  'X-CSRF-TOKEN'
] = document.head.querySelector('meta[name="csrf-token"]').content;

Vue.component('flash', Flash);

window.Swal = Swal.mixin({
  reverseButtons: true,
  showCloseButton: true,
  confirmButtonColor: '#03a9f4',
  confirmButtonClass: 'button is-primary',
  cancelButtonClass: 'button is-danger is-medium',
  cancelButtonColor: '#f44336'
});

window._ = _;

window.Vue = Vue;

new Sticky('.sticky-product-logo', {
  marginTop: 10
});

document.addEventListener('DOMContentLoaded', () => {
  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll('.navbar-burger'),
    0,
  );

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach($el => {
      $el.addEventListener('click', () => {
        // Get the target from the 'data-target' attribute
        const $target = document.getElementById($el.dataset.target);

        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
        $el.classList.toggle('is-active');
        $target.classList.toggle('is-active');
      });
    });
  }
});
